import React, { Component } from 'react';
import '../../../css/responsive.css';

class CutTransferComponent extends Component {

    onChangeF = (field, value) => {
        const { props } = this.props;
        const { searchData, refreshSearch } = props;
        let newValue = value ?? '';

        if (field === 'IdOTRC') { // SOLO NÚMEROS ENTEROS
            newValue = String(newValue)?.replace(/\D/g, '');
        }

        if (['IdOTRC']?.includes(field)) {
            newValue = newValue?.slice(0, 10);
        }

        if (['UsrOri', 'UsrDes']?.includes(field)) {
            newValue = newValue?.slice(0, 25);
        }

        const newSearchData = {
            ...searchData,
            [field]: newValue
        };

        refreshSearch(newSearchData);
    };

    render() {
        const { props } = this.props;
        const { search, searchData } = props;

        return (
            <div className="cut-transfer-filters">

                {/* FECHA DESDE */}
                <div className="filter-group mb-2">
                    <label><strong>Desde:</strong></label>
                    <input
                        type="date"
                        className="form-control filter-input"
                        style={{ height: 44, borderRadius: 12, backgroundColor: '#f9fafb', width: 180 }}
                        value={searchData?.dateFrom || ''}
                        onChange={(e) => this.onChangeF('dateFrom', e.target.value)}
                    />
                </div>

                {/* FECHA HASTA */}
                <div className="filter-group mb-2">
                    <label><strong>Hasta:</strong></label>
                    <input
                        type="date"
                        className="form-control filter-input"
                        style={{ height: 44, borderRadius: 12, backgroundColor: '#f9fafb', width: 180 }}
                        value={searchData?.dateTo || ''}
                        onChange={(e) => this.onChangeF('dateTo', e.target.value)}
                    />
                </div>

                {/* TRASPASO */}
                <div className="filter-group mb-2">
                    <label><strong>Traspaso:</strong></label>
                    <input
                        type="text"
                        className="form-control filter-input"
                        style={{ height: 44, borderRadius: 12, backgroundColor: '#f9fafb', width: 150 }}
                        placeholder="Traspaso #"
                        value={searchData?.IdOTRC || ''}
                        onChange={(e) => this.onChangeF('IdOTRC', e.target.value)}
                    />
                </div>

                {/* USUARIO ORIGEN */}
                <div className="filter-group mb-2">
                    <label><strong>Origen:</strong></label>
                    <input
                        type="text"
                        className="form-control filter-input"
                        style={{ height: 44, borderRadius: 12, backgroundColor: '#f9fafb', width: 150 }}
                        placeholder="Usuario origen"
                        value={searchData?.UsrOri || ''}
                        onChange={(e) => this.onChangeF('UsrOri', e.target.value)}
                    />
                </div>

                {/* USUARIO DESTINO */}
                <div className="filter-group mb-2">
                    <label><strong>Destino:</strong></label>
                    <input
                        type="text"
                        className="form-control filter-input"
                        style={{ height: 44, borderRadius: 12, backgroundColor: '#f9fafb', width: 150 }}
                        placeholder="Usuario destino"
                        value={searchData?.UsrDes || ''}
                        onChange={(e) => this.onChangeF('UsrDes', e.target.value)}
                    />
                </div>

                {/* ACEPTADO POR */}
                <div className="filter-group mb-2">
                    <label><strong>Aceptado:</strong></label>
                    <input
                        type="text"
                        className="form-control filter-input"
                        style={{ height: 44, borderRadius: 12, backgroundColor: '#f9fafb', width: 150 }}
                        placeholder="Aceptado por"
                        value={searchData?.AcceptBy || ''}
                        onChange={(e) => this.onChangeF('AcceptBy', e.target.value)}
                    />
                </div>

                {/* TIPO DE CORTE */}
                <div className="filter-group mb-2">
                    <label><strong>Tipo:</strong></label>
                    <select
                        className="form-control filter-input"
                        style={{ height: 44, borderRadius: 12, backgroundColor: '#f9fafb', width: 160 }}
                        value={searchData?.ShiftType || ''}
                        onChange={(e) => this.onChangeF('ShiftType', e.target.value)}
                    >
                        <option value="">Todos</option>
                        <option value="O">Corte Abierto</option>
                        <option value="C">Corte Cerrado</option>
                    </select>
                </div>

                {/* STATUS */}
                <div className="filter-group mb-2">
                    <label><strong>Estatus:</strong></label>
                    <select
                        className="form-control filter-input"
                        style={{ height: 44, borderRadius: 12, backgroundColor: '#f9fafb', width: 160 }}
                        value={searchData?.Status || ''}
                        onChange={(e) => this.onChangeF('Status', e.target.value)}
                    >
                        <option value="">Todos</option>
                        <option value="P">Pendiente</option>
                        <option value="R">Reasignado</option>
                        <option value="C">Aceptado / Cerrado</option>
                    </select>
                </div>

                {/* BUSCAR */}
                <div className="mr-3 mb-2">
                    <button
                        className="btn btn-active"
                        title="Buscar"
                        onClick={search}
                    >
                        <i className="fas fa-search"></i>
                    </button>
                </div>

            </div>
        );
    }
}

export default CutTransferComponent;